import createKeys from '../../utilities/createKeys'

export const Keys = createKeys('AGENT', [
    'FORM_AGENT',
    'FORM_CONTACT',
    'FORM_ADDRESS',
    'TABLE_CONTACT',
    'TABLE_ADDRESS'
])
